// apps/web/src/hooks/use-prefers-reduced-motion.ts — Fase 17.8, Plano 03 (U-23, U-28).
// Lê `prefers-reduced-motion: reduce` e acompanha a mudança; no servidor/teste (sem window) devolve false.
import { useEffect, useState } from 'react';

const CONSULTA = '(prefers-reduced-motion: reduce)';

function lerPreferencia(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(CONSULTA).matches;
}

export function usePrefersReducedMotion(): boolean {
  const [reduzido, setReduzido] = useState<boolean>(lerPreferencia);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const consulta = window.matchMedia(CONSULTA);
    const aoMudar = (): void => setReduzido(consulta.matches);
    consulta.addEventListener('change', aoMudar);
    aoMudar();
    return () => consulta.removeEventListener('change', aoMudar);
  }, []);

  return reduzido;
}
